import { useEffect, useState } from 'react'
import { useWorkspace } from 'hooks/useWorkspace'

const LOGO_HEIGHT = 40
const COLLAPSED_MAX_WIDTH = 60
const EXPANDED_MAX_WIDTH = 200

export const useWorkspaceLogoSize = (isCollapsed?: boolean) => {
  const { currentWorkspace } = useWorkspace()
  const [naturalDims, setNaturalDims] = useState<{ w: number; h: number } | null>(null)

  const logoUrl = currentWorkspace?.logoUrl

  useEffect(() => {
    if (!logoUrl) {
      setNaturalDims(null)
      return
    }
    const img = new Image()
    img.onload = () => setNaturalDims({ w: img.naturalWidth, h: img.naturalHeight })
    img.src = logoUrl
  }, [logoUrl])

  const aspectRatio = naturalDims ? naturalDims.w / naturalDims.h : 1
  const maxWidth = isCollapsed ? COLLAPSED_MAX_WIDTH : EXPANDED_MAX_WIDTH

  let height = LOGO_HEIGHT
  let width = height * aspectRatio

  if (width > maxWidth) {
    width = maxWidth
    height = width / aspectRatio
  }

  return { width, height, isReady: !!naturalDims }
}
